import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { CHART_BORDER_WIDTH, CHART_FILL_ALPHA, getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardBarChart({ series = [], horizontal = false, percentage = false }) {
    const categories = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        colors,
        fill: { type: 'solid', opacity: CHART_FILL_ALPHA },
        stroke: {
            show: true,
            width: CHART_BORDER_WIDTH,
            colors,
        },
        states: {
            hover: { filter: { type: 'darken', value: 0.12 } },
        },
        plotOptions: {
            bar: {
                horizontal,
                borderRadius: 8,
                borderRadiusApplication: 'end',
                distributed: true,
                columnWidth: horizontal ? '55%' : '48%',
                barHeight: horizontal ? '65%' : undefined,
            },
        },
        dataLabels: {
            enabled: false,
        },
        legend: { show: false },
        xaxis: {
            categories,
            labels: {
                rotate: horizontal ? 0 : -25,
                style: { fontSize: horizontal ? '12px' : '11px', colors: '#6c757d' },
            },
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            min: 0,
            max: percentage ? 100 : undefined,
            forceNiceScale: !percentage,
            labels: {
                style: { colors: '#6c757d', fontSize: '12px' },
                formatter: percentage ? (val) => `${val}%` : undefined,
            },
        },
        grid: {
            borderColor: '#f1f3f8',
            strokeDashArray: 4,
            padding: { left: 8, right: 8 },
        },
        tooltip: {
            y: {
                formatter: (val) => (percentage ? `${val.toFixed(1)}%` : val.toLocaleString()),
            },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={[{ name: percentage ? 'Coverage' : 'Count', data: values }]}
            type="bar"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardBarChart;
